import {HttpClient, HttpParams} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable, switchMap} from 'rxjs';
import {TrainingService} from 'src/app/training.service';

export interface BillingAddress {
  city: string;
  countryId: string;
  firstName: string;
  lastName: string;
  postCode: string;
  regionCode: string;
  street: string[];
  telephone: string;
}

export interface CartInfo {
  cartId: string;
  billingAddress: BillingAddress;
}

@Injectable({providedIn: 'root'})
export class CheckoutService {
  private trainingService = inject(TrainingService);
  private httpClient = inject(HttpClient);

  getPaymentToken(webAppId: string): Observable<any> {
    return this.trainingService.load().pipe(
      switchMap((api) =>
        this.httpClient.get(
          `${api.getRoute('getBraintreePaymentToken').replace('{webAppId}', webAppId)}`,
          {
            responseType: 'text'
          }
        )
      )
    );
  }

  createCart(webAppId: string): Observable<any> {
    return this.trainingService.load().pipe(
      switchMap((api) => {
        const params = new HttpParams().set('webAppId', webAppId);

        return this.httpClient.post(`${api.getRoute('createCart')}`, null, {
          params
        });
      })
    );
  }

  saveBillingAddress(cartId: string, billingAddress: BillingAddress): Observable<any> {
    return this.trainingService.load().pipe(
      switchMap((api) => {
        return this.httpClient.post(
          `${api.getRoute('setBillingAddress').replace('{cartId}', cartId)}`,
          billingAddress
        );
      })
    );
  }

  placeOrder(cartId: string, nonce: string): Observable<any> {
    return this.trainingService.load().pipe(
      switchMap((api) => {
        const params = new HttpParams().set('nonce', nonce);

        return this.httpClient.post(
          `${api.getRoute('placeOrder').replace('{cartId}', cartId)}`,
          null,
          {
            params
          }
        );
      })
    );
  }
}
